import { useEffect, useState } from "react";
import { Loader2, History, Search, ShieldCheck } from "lucide-react";
import { adminApi } from "@/lib/api";
import { Input } from "@/components/ui/input";

const when = (iso) => (iso ? String(iso).slice(0, 16).replace("T", " ") : "—");
const AREA_CLS = { stores: "bg-[#FBEEF4] text-[#28282E]", reports: "bg-slate-100 text-[#28282E]", users: "bg-amber-100 text-amber-800", catalogue: "bg-emerald-100 text-emerald-800", settings: "bg-blue-100 text-blue-800", orders: "bg-orange-100 text-orange-800" };

export default function ActivityLog() {
  const [items, setItems] = useState(null);
  const [denied, setDenied] = useState(false);
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => adminApi.activityLog(q).then((r) => setItems(r.items)).catch((e) => { if (e.response?.status === 403) setDenied(true); }), 250);
    return () => clearTimeout(t);
  }, [q]);

  if (denied) return <div className="rounded-3xl border border-dashed border-slate-300 p-12 text-center" data-testid="activity-no-access"><ShieldCheck className="mx-auto mb-3 h-8 w-8 text-[#28282E]/40" /><p className="font-semibold text-[#28282E]">Admins only</p></div>;
  return (
    <div data-testid="admin-activity-page">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div><h1 className="font-serif text-3xl font-bold text-[#28282E]">Activity Log</h1><p className="text-sm text-[#28282E]/70">Who changed what on the Supplier Admin side — store edits, report saves, PIN resets, user changes.</p></div>
        <div className="relative"><Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-[#28282E]/40" /><Input data-testid="activity-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search person, action or store…" className="w-72 pl-9" /></div>
      </div>
      {!items ? <div className="grid place-items-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#28282E]/50" /></div> : (
        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-[11px] uppercase text-[#28282E]/60"><tr><th className="px-4 py-2">When</th><th className="px-4 py-2">Who</th><th className="px-4 py-2">Action</th><th className="px-4 py-2">Target</th><th className="px-4 py-2">Area</th></tr></thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} data-testid={`activity-row-${a.id}`} className="border-t border-slate-100">
                  <td className="whitespace-nowrap px-4 py-2.5 text-xs text-[#28282E]/70">{when(a.at)}</td>
                  <td className="px-4 py-2.5"><div className="font-semibold text-[#28282E]">{a.actor_name}</div><div className="text-[11px] text-[#28282E]/55">{a.actor_email} · {a.actor_role}</div></td>
                  <td className="px-4 py-2.5 font-medium text-[#28282E]">{a.action}</td>
                  <td className="px-4 py-2.5 font-mono text-xs text-[#28282E]/80">{a.target || <span className="text-[#28282E]/30">—</span>}</td>
                  <td className="px-4 py-2.5"><span className={`rounded-full px-2 py-0.5 text-[11px] font-bold capitalize ${AREA_CLS[a.area] || "bg-slate-100"}`}>{a.area}</span></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-sm text-[#28282E]/50"><History className="mx-auto mb-2 h-6 w-6" /> No activity recorded yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
